import React, { Component } from 'react'

class Titles extends Component {
    render() {
        return (
            <div className="title">
                <h1> What's the weather like?</h1>
                <p>Find out the temperature, forecast and more...</p>
            </div>
        )
    }
}
export default Titles;